import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import api from '@calendar/api'
import * as accountTypes from '@account/store/types'
import { mapGetters } from 'vuex'
@Component({
    computed: {
        ...mapGetters({
            User: accountTypes.USER,
            //item: types.CURRENT_CALENDAR_ITEM
        }),
    },
})
export default class MeetingRoomModal extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    // 이수 - 회의실 목록에 db 자원관리 회의실 목록과 연동
    conferenceList: any[] = [];

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean, default: false }) show!: boolean
    @Prop({ type: Object }) value!: calendar.CalendarItem

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    /**
     * 현재 회의실을 가져옵니다
     */
    get currentResources() {
        return this.value.ui_resourceArray
    }

    /**
     * 선택한 회의실로 바인딩합니다
     */
    set currentResources(value: Array<any>) {
        this.value.ui_resourceArray = value
    }

    created() {
        api.db_resourceReserve.getConferenceResource(this.User.comCode).then((res: any[]) => {
            this.conferenceList = res
        })
    }
}
